import { useEffect, useState } from 'react';
import { getCandidatePortalAccess, type CandidatePortalAccess } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { usePlatform } from '@/contexts/PlatformContext';

export function useCandidatePortalAccess() {
  const { user } = useAuth();
  const { isClosed } = usePlatform();
  const [access, setAccess] = useState<CandidatePortalAccess | null>(null);
  const [loading, setLoading] = useState(Boolean(user));

  useEffect(() => {
    let cancelled = false;
    if (!user) {
      setAccess(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    getCandidatePortalAccess()
      .then((result) => {
        if (!cancelled) setAccess(result);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  const canUseApplicantActions =
    access?.canUseApplicantActions ?? (!isClosed && Boolean(user));

  return {
    access,
    loading,
    canUseApplicantActions,
    overrideExpiresAt: access?.overrideExpiresAt ?? null,
    // Directed candidates apply to an assigned role, which carries no job choice and is not
    // counted against the self-service application limit.
    isDirectedToAssignedJobs: access?.jobScope === 'assigned_only',
  };
}
